<template>
  <div
    class="calico-file-dropzone"
    @drop.prevent="drop"
    @dragover.prevent
    @dragover="dragover"
    @dragleave="dragleave"
  >
    <div>
      <label class="body--medium body--medium-bold">Drag & drop files or 
        <input
          ref="fileInput"
          type="file"
          hidden
          v-bind="$attrs"
          @input="(e) => e.target.value"
          @change.prevent="onBrowse"
        >
        <span style="display: inline-block;">
          <button
            class="button-link"
            @click.prevent="$refs.fileInput.click()"
          >
            Browse
          </button>
        </span>
      </label>
    </div>
    <label class="body--xsmall">Supported formats: JPEG, PNG, PDF</label>
    <label class="body--xsmall">Max file size: 10mb</label>
  </div>
</template>

<script lang="js">
export default {
  name: 'CalicoFileDropzone',
  data () {
    return {}
  },
  methods: {
    onBrowse (e) {
      this.$emit('browse', e.target.files)
      e.target.value = null
    },
    drop (e) {
      this.$emit('browse', e.dataTransfer.files)
      this.dragleave(e)
    },
    dragover (e) {
      e.preventDefault()
      e.currentTarget.classList.add('calico-file-dropzone-dropping')
    },
    dragleave (e) {
      e.currentTarget.classList.remove('calico-file-dropzone-dropping')
    }
  }
}
</script>

<style lang="scss">
.calico-file-dropzone {
  @include stack-space($space-none);
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  border: 1px solid $color-border-primary;
  border-radius: 4px;
  border-style: dashed;
  label {
    margin: 0px;
    color: $color-text-secondary;
  };
  .button--link {
    display: flex;
  }
}
.calico-file-dropzone-dropping {
  background: $color-neutral-lightest;
}
</style>
